import { FC } from 'react';
import { Link } from '@/components/ui';
import LazyNavImage from '@/components/ui/image/lazy-nav-image';
import { selectCategoryImage } from '@/utils/select-category-image';

interface MiniCategoryCardProps {
  image: string;
  name: string;
  metaUrl: string;
}

const MiniCategoryCard: FC<MiniCategoryCardProps> = ({ image, name, metaUrl }) => {
  return (
    <Link
      href={`/products/${metaUrl}`}
      className="hover:bg-default-200 h-full rounded-lg p-4 transition-colors"
    >
      <div className="flex h-full flex-col rounded-md">
        <div className="relative min-h-0 w-full flex-1 overflow-hidden rounded-md shadow-md">
          <LazyNavImage src={selectCategoryImage(image)} alt={name} />
        </div>
        <div className="mt-2">
          <div>
            <span className="block text-sm font-normal text-neutral-700">{name}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default MiniCategoryCard;
